import React from 'react';

/**
 * EloChange component for displaying ELO rating changes with proper color coding
 * Shows green for positive changes, red for negative changes
 */
const EloChange = ({ 
  change, 
  showSign = true, 
  showArrow = false,
  size = 'sm', // 'xs', 'sm', 'md', 'lg'
  className = ''
}) => {
  if (!change && change !== 0) return null;

  const isPositive = change > 0;
  const isZero = change === 0;
  
  // Define size variants
  const getSizeClasses = () => {
    switch (size) {
      case 'xs':
        return 'text-xs';
      case 'sm':
        return 'text-sm';
      case 'md':
        return 'text-base';
      case 'lg':
        return 'text-lg';
      default:
        return 'text-sm';
    }
  };

  // Define color classes
  const getColorClasses = () => {
    if (isZero) return 'text-gray-500';
    return isPositive ? 'text-green-600' : 'text-red-600';
  };

  // Format the change value
  const formatChange = () => {
    const absChange = Math.abs(change);
    const sign = showSign && !isZero ? (isPositive ? '+' : '-') : '';
    return `${sign}${absChange}`;
  };

  // Get arrow symbol
  const getArrow = () => {
    if (!showArrow) return '';
    if (isZero) return '→';
    return isPositive ? '↗' : '↘';
  };

  return (
    <span className={`font-medium ${getSizeClasses()} ${getColorClasses()} ${className}`}>
      {getArrow()}{getArrow() && ' '}{formatChange()}
    </span>
  );
};

export default EloChange;
